import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import { useTranslation } from "react-i18next";
import PhotoTagsContent from "../../components/Pages/PhotoTags";

const { displayName } = config;

export default function PhotoTags() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Photo Tags`;
  }, []);

  return (
    <Layout title="Photo Tags">
      <div style={{ marginBottom: 0, width: "100%" }}>
        <PhotoTagsContent />
      </div>
    </Layout>
  );
}
